<script setup lang="ts">
  import type { FindOrderOut } from '~/types/ecommerce/generated.codegen';

  const props = defineProps<{
    order: FindOrderOut;
  }>();

  const isCIF = computed(() => props.order.delivery.type === 'CIF');
</script>

<template>
  <OrdersShippingDetailCardCif v-if="isCIF" :delivery="order.delivery" />
  <OrdersShippingDetailCardFob v-else :delivery="order.delivery" />
</template>
